import { AnalyticsPlugin } from 'analytics';
import isEmpty from 'lodash/isEmpty';

import { hasMarketingConsent } from '../../cookieStore/functions/hasMarketingConsent';
import { TrackingPixelVendor } from '../enums/TrackingPixelVendor';
import { TrackingPixel } from '../types/TrackingPixel';
import { TrackingPixelPluginPayload } from '../types/TrackingPixelPluginPayload';

export const createTrackingPixelPlugin = (
  vendor: TrackingPixelVendor,
  send: (pixels: TrackingPixel[], payload: TrackingPixelPluginPayload) => void,
): AnalyticsPlugin => ({
  name: vendor,
  track: ({ payload }: { payload: TrackingPixelPluginPayload }): void => {
    const pixels = (payload.options?.pixels ?? []).filter(
      (pixel): boolean => pixel.vendor === vendor,
    );

    // every tracking pixel counts as Marketing, so nothing is sent unless the
    // visitor has accepted that category in the consent manager. It has to be
    // checked here because the consent manager only blocks <script> tags: it
    // can't stop image or iframe pixels, or a vendor script that loaded before
    // the visitor opted out (the portal never reloads to unload it)
    if (isEmpty(pixels) || !hasMarketingConsent()) {
      return;
    }

    try {
      send(pixels, payload);
    } catch (error: unknown) {
      // a throw inside @analytics is an unhandled rejection, and it skips the
      // plugins after this one, Google Tag Manager included
      console.error(error);
    }
  },
});
